import Faq from '../../components/Faq';
import Meta from '../../components/Meta';
import বিশালমূল্যছাড় from '../../assets/images/বিশাল-মূল্যছাড়.png';
import uddokta_og_img from "../../assets/og-img/Startup Packages.png";
import Marquee from 'react-fast-marquee';
import { startupRelatedArticales } from '../../data/relatedArticale';

function UddoktaPackage() {
    const faqItems = [
        {
            title: 'What is a startup plan?',
            content: <strong>A startup business plan is a written document that outlines your ideas and strategies for launching, managing, and eventually exiting your new venture.</strong>
        },
        {
            title: 'What is start up model?',
            content: <strong>Your startup business model essentially explains how your business will operate and make money—and it also takes into account the cost structure.</strong>
        },
        {
            title: 'How do I create a startup plan?',
            content: <strong>A Step by Step Guide to Creating an Effective Startup Project... Define your project. As a startup, you need to have a clear and concise project plan</strong>
        }
    ];


    const sectionTitle = {
        fontSize: '26px',
        fontWeight: '700',
        textAlign: 'center',
        marginBottom: '30px',
        color: '#0d6efd'
    };


    return (
        <>
            <Meta
                title="Setting up a startup business in Bangladesh | JK Associates"
                description="Setting up a startup in Bangladesh involves several key steps..."
                image={uddokta_og_img}
                keywords="startup package, startup business Bangladesh, startup business registration, Setting up a startup in Bangladesh"
            />

            {/* Hero Section */}
            <div
  className="container-fluid hero-header bg-light py-5"
  style={{
    backgroundColor: '#f8f9fa',
    paddingTop: '80px',
    paddingBottom: '80px',
    overflow: 'hidden',
    fontFamily: `'Segoe UI', Tahoma, Geneva, Verdana, sans-serif`
  }}
>
  <div className="container py-5">
    <div className="row g-5 align-items-center">

      {/* Left Text Section */}
      <div
        className="col-lg-6"
        style={{
          animation: 'slideInLeft 1s ease forwards',
          opacity: 0
        }}
      >
        <h1 style={{
          fontSize: '42px',
          fontWeight: '700',
          color: '#0d6efd',
          marginBottom: '20px',
          animation: 'fadeInUp 1.5s ease 0.2s forwards',
          opacity: 0
        }}>
          Startup Business
        </h1>
        <p style={{
          fontSize: '16px',
          lineHeight: '1.6',
          color: '#333',
          animation: 'fadeInUp 1.5s ease 0.4s forwards',
          opacity: 0
        }}>
          Setting up a startup in Bangladesh involves several key steps: securing name clearance, drafting and submitting necessary documents, opening a bank account, registering with relevant authorities (RJSC, tax, VAT, trade license), and potentially obtaining additional licenses.
        </p>
      </div>

      {/* Right Image Section */}
      <div
        className="col-lg-6"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          animation: 'slideInRight 1s ease 0.6s forwards',
          opacity: 0
        }}
      >
        <img
          src={বিশালমূল্যছাড়}
          alt="বিশাল-মূল্যছাড়"
          className="img-fluid"
          style={{
            maxWidth: '100%',
            animation: 'pulse 3s ease-in-out infinite'
          }}
        />
      </div>
    </div>
  </div>

  {/* Inline CSS Animations */}
  <style>
    {`
      @keyframes slideInLeft {
        0% {
          transform: translateX(-100px);
          opacity: 0;
        }
        100% {
          transform: translateX(0);
          opacity: 1;
        }
      }

      @keyframes slideInRight {
        0% {
          transform: translateX(100px);
          opacity: 0;
        }
        100% {
          transform: translateX(0);
          opacity: 1;
        }
      }

      @keyframes fadeInUp {
        0% {
          transform: translateY(20px);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }

      @keyframes pulse {
        0% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.03);
        }
        100% {
          transform: scale(1);
        }
      }
    `}
  </style>
</div>



            {/* Packages Section */}
            <div className="container" style={{ padding: '60px 15px' }}>
  <h2 style={{
    fontSize: '32px',
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: '40px',
    color: '#0d6efd',
    fontFamily: `'Segoe UI', Tahoma, Geneva, Verdana, sans-serif`
  }}>
    Our Startup Packages
  </h2>

  <div style={{
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '30px',
  }}>
    {[
      {
        title: "Basic Package",
        price: "৩৯,৯৯৯ TK",
        color: "#E53935", // Red
        features: {
          consultation: true,
          document: true,
          registration10Lac: true,
          registration40Lac: false,
          registration1Cr: false,
          tin: true,
          license5Lac: true,
          license10Lac: false,
          license50Lac: false,
          bank: true,
          stamp: true,
          bin: false,
          trademark: false,
          copyright: false,
          taxConsult: false,
          domainHosting: false,
          website: false,
          logo: false,
          social: false,
        }
      },
      {
        title: "Standard Package",
        price: "৮৮,৯৯৯ TK",
        color: "#1E88E5", // Blue
        features: {
          consultation: true,
          document: true,
          registration10Lac: false,
          registration40Lac: true,
          registration1Cr: false,
          tin: true,
          license5Lac: false,
          license10Lac: true,
          license50Lac: false,
          bank: true,
          stamp: true,
          bin: true,
          trademark: true,
          copyright: true,
          taxConsult: true,
          domainHosting: false,
          website: false,
          logo: false,
          social: false,
        }
      },
      {
        title: "Premium Package",
        price: "১,২৯,৯৯৯ TK",
        color: "#43A047", // Green
        features: {
          consultation: true,
          document: true,
          registration10Lac: false,
          registration40Lac: false,
          registration1Cr: true,
          tin: true,
          license5Lac: false,
          license10Lac: false,
          license50Lac: true,
          bank: true,
          stamp: true,
          bin: true,
          trademark: true,
          copyright: true,
          taxConsult: true,
          domainHosting: true,
          website: true,
          logo: true,
          social: true,
        }
      }
    ].map((pkg, index) => (
      <div
        key={index}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: '100%',
          maxWidth: '340px',
          backgroundColor: pkg.color,
          color: '#fff',
          borderRadius: '12px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
          padding: '30px',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          textAlign: 'left',
          fontFamily: `'Segoe UI', Tahoma, Geneva, Verdana, sans-serif`,
          minHeight: '680px'
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'scale(1.04)';
          e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.08)';
        }}
      >
        <div>
          <h3 style={{
            fontSize: '22px',
            fontWeight: '700',
            marginBottom: '5px',
            color: '#fff'
          }}>{pkg.title}</h3>

          <div style={{
            fontSize: '20px',
            fontWeight: '600',
            marginBottom: '10px',
            color: '#fff'
          }}>{pkg.price}</div>

          <div style={{
            fontSize: '14px',
            color: '#f0f0f0',
            marginBottom: '20px'
          }}>*EMI Available</div>

          <ul style={{
            listStyleType: 'none',
            padding: 0,
            marginBottom: '25px',
            fontSize: '15px',
            lineHeight: '1.7',
          }}>
            {[
              { label: 'Business Consultation', key: 'consultation' },
              { label: 'Document Preparation', key: 'document' },
              { label: 'Company Registration (10 Lac)', key: 'registration10Lac' },
              { label: 'Company Registration (40 Lac)', key: 'registration40Lac' },
              { label: 'Company Registration (1 Cr)', key: 'registration1Cr' },
              { label: 'Company TIN Registration', key: 'tin' },
              { label: 'Trade License (5 Lac)', key: 'license5Lac' },
              { label: 'Trade License (10 Lac)', key: 'license10Lac' },
              { label: 'Trade License (50 Lac)', key: 'license50Lac' },
              { label: 'Bank Account Assistance', key: 'bank' },
              { label: 'Company Stamp', key: 'stamp' },
              { label: 'BIN Registration', key: 'bin' },
              { label: 'Trademark Application', key: 'trademark' },
              { label: 'Copyright Registration', key: 'copyright' },
              { label: 'TAX Expert Consultation', key: 'taxConsult' },
              { label: 'Domain & Hosting (1yr)', key: 'domainHosting' },
              { label: 'Company Portfolio Website', key: 'website' },
              { label: 'Company Logo Design', key: 'logo' },
              { label: 'Social Media Setup', key: 'social' }
            ].map((feature, i) => (
              <li key={i} style={{ marginBottom: '8px', display: 'flex', alignItems: 'start' }}>
                <span style={{
                  marginRight: '8px',
                  fontWeight: 'bold',
                  color: pkg.features[feature.key] ? '#fff' : '#ccc'
                }}>{pkg.features[feature.key] ? '✓' : '✕'}</span>
                <span style={{ color: pkg.features[feature.key] ? '#fff' : '#ddd' }}>
                  {feature.label}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div style={{ textAlign: 'center', marginTop: 'auto' }}>
          <button
            style={{
              backgroundColor: '#fff',
              color: pkg.color,
              padding: '10px 18px',
              border: 'none',
              borderRadius: '6px',
              fontWeight: '600',
              fontSize: '14px',
              marginRight: '10px',
              cursor: 'pointer',
              transition: 'background 0.3s ease'
            }}
            onMouseOver={e => e.currentTarget.style.backgroundColor = '#f0f0f0'}
            onMouseOut={e => e.currentTarget.style.backgroundColor = '#fff'}
          >
            Order Now
          </button>
          <button
            style={{
              backgroundColor: 'transparent',
              color: '#fff',
              border: `1px solid #fff`,
              padding: '10px 18px',
              borderRadius: '6px',
              fontWeight: '600',
              fontSize: '14px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={e => {
              e.currentTarget.style.backgroundColor = '#fff';
              e.currentTarget.style.color = pkg.color;
            }}
            onMouseOut={e => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#fff';
            }}
          >
            Learn More
          </button>
        </div>
      </div>
    ))}
  </div>
</div>


            {/* Related Articles */}
            <div className="container-xxl" style={{ background: '#f8fafc', padding: '50px 0' }}>
                <h2 style={sectionTitle}>Related Articles</h2>
                <Marquee>
                    {startupRelatedArticales}
                </Marquee>
            </div>

            {/* FAQ Section */}
            <div className="container py-5">
                <h2 style={sectionTitle}>Uddokta Package FAQ</h2>
                <Faq items={faqItems} />
            </div>
        </>
    );
}

export default UddoktaPackage;
